import React from "react";
import { inject, observer } from "mobx-react/index";
import Spinner from "../Spinner";
import { Link } from "react-router";
import DataTable from "../DataTable";
import { toJS } from "mobx";
import moment from "moment";

@inject(
  "stationStore",
  "userStore",
  "tripStore",
  "workOrderStore",
  "ticketStore"
)
@observer
class TripList extends React.Component {
  componentWillMount() {
    const {
      stationStore,
      userStore,
      tripStore,
      workOrderStore
    } = this.props;

    if (!stationStore.items.length) stationStore.fetchItems();
    if (!userStore.items.length) userStore.fetchItems();
    if (!tripStore.items.length) tripStore.fetchItems()
    if (!workOrderStore.items.length) workOrderStore.fetchItems()
  }

  handleDelete = (id) => {
    this.props.tripStore.removeItems(id);
  };

  flattenData = () => {
    const {userStore, tripStore} = this.props;

    const result = []
    const data = tripStore.items
    data.forEach((element, index) => {
      const planned_by = userStore.findById(element.planned_by).name;
      const commutatorsName = element.commutators.map((item) => userStore.findById(item).name).join(',')
      const station_names = element.station_name ? element.station_name.join(',') : null
  
      result.push({
        id:element.id,
        station_name:station_names,
        sn:index + 1,
        tripnumber:<Link to={`/monitoring/trip/map/${element.id}/view`}>{`TN${10000 + (index + 1)}`|| 'View'}</Link>,
        planned_by:planned_by,
        start_date:moment(element.start_date).format('YYYY-MM-DD'),
        end_date:moment(element.end_date).format('YYYY-MM-DD'),
        commutators:commutatorsName,
        region:element.region
      })
    });

    return result;
  };

  render() {
    if (
      this.props.stationStore.isLoading ||
      this.props.userStore.isLoading || 
      this.props.tripStore.isLoading ||
      this.props.ticketStore.isLoading || 
      this.props.workOrderStore.isLoading
    ) return <Spinner />;
    const data = this.flattenData()

    return (
      <div>
        <DataTable
          columns={[
            { key: "sn", label: "ID" },
            { key: "tripnumber", label: "Trip Number" },
            { key:'station_name', label:'Station Name'},
            { key: "region", label: "Region" },
            { key: "start_date", label: "Start Date" },
            { key: "end_date", label: "End Date" },
            { key: "commutators", label: "Commutators" },
            { key: "planned_by", label: "Planned By" },
          ]}
          data={data}
          slug={"monitoring/trip/tabular"}
          allowAdd
          allowEdit
          allowDelete
          onDelete={this.handleDelete}
          disableMultipleDelete
        />
        {this.props.children}
      </div>
    );
  }
}

export default TripList;



// WEBPACK FOOTER //
// ./src/components/Trips/TripList.js